/**
 * DL Fork: BI bridge root component.
 *
 * Mounted once in the app root layout (inside the router + react-query context).
 * Renders nothing. When (and only when) the channel is active — embedded build,
 * framed, and a validated wrapper origin — it wires the inbound navigate /
 * data-changed listeners, the global refresh-on-data-changed, and the outbound
 * context emitter. Inactive (standalone build, non-embedded, or unvalidated
 * origin) ⇒ fully inert; the inner component that runs the project/nav hooks is
 * not even mounted, so no extra queries fire outside the embedded case.
 */
import { type FC } from 'react';
import {
    useBiContextEmitter,
    useBiGlobalInvalidation,
    useBiInboundBridge,
    useValidatedBridgeOrigin,
} from './useBiBridge';

const DlBiActiveBridge: FC<{ origin: string }> = ({ origin }) => {
    useBiInboundBridge(origin);
    useBiGlobalInvalidation();
    useBiContextEmitter(origin);
    return null;
};

const DlBiBridge: FC = () => {
    const origin = useValidatedBridgeOrigin();
    if (!origin) return null;
    return <DlBiActiveBridge origin={origin} />;
};

export default DlBiBridge;
